module.exports = __webpack_public_path__ + "static/img/no1.931799b9.png";